import { useIMCContext } from 'modules/IMC/common/context';
import useMessageCenterCopy from 'modules/IMC/common/hooks/useMessageCenterCopy';
import HelpAgentIcon from 'modules/common/components/Icons/HelpAgentIcon';
import ChipButton from 'modules/common/components/Layout/Header/ChipButton';

export default function HelpAgentButton() {
    const { openHelpAgentWidget } = useIMCContext();
    const { helpButtonLabel } = useMessageCenterCopy();

    const handleClick = () => {
        openHelpAgentWidget({ source: 'help_agent_button' });
    };

    return (
        <>
            {/* Desktop view - always render */}
            <ChipButton
                onClick={handleClick}
                variant="outlined"
                icon={<HelpAgentIcon />}
                label={<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{helpButtonLabel}</div>}
                sx={{ display: { xs: 'none', md: 'inline-flex' } }}
            />
            {/* Mobile view - always render */}
            <ChipButton
                onClick={handleClick}
                variant="outlined"
                icon={<HelpAgentIcon sx={{ fontSize: '1em' }} />}
                label=""
                sx={{
                    display: { xs: 'inline-flex', md: 'none' },
                    '& .MuiChip-label': { display: 'none' },
                    '& .MuiChip-icon': { margin: 0 },
                    minWidth: 'auto',
                    padding: '8px 16px',
                }}
            />
        </>
    );
}
